/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202609.19.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateClick { 
    url: string;
    source: CreateClick.SourceEnum;
}
export namespace CreateClick {
    export type SourceEnum = 'loyalty_page' | 'pass' | 'webapp' | 'widget';
    export const SourceEnum = {
        LoyaltyPage: 'loyalty_page' as SourceEnum,
        Pass: 'pass' as SourceEnum,
        Webapp: 'webapp' as SourceEnum,
        Widget: 'widget' as SourceEnum
    };
}


